import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { Coordinates } from '@awesome-cordova-plugins/geolocation/ngx';
import { ConfermaPresenza } from '../models/rilevazione-presenze/conferma-presenza';
import { Presenza } from '../models/rilevazione-presenze/presenza';
import { RichiestaDiConferma } from '../models/rilevazione-presenze/richiesta-conferma';
import { Rilevazione } from '../models/rilevazione-presenze/rilevazione';
import { RilevazionePresenzeService } from './rilevazione-presenze-service';
import { addMinutes } from 'date-fns';
import { UtilityService } from './utility.service';

/**
 * Fornisce i servizi relativi alla didattica
 */
@Injectable( { providedIn: 'root' })
export class ConfermaPresenzaService {

  optionsContJson = {headers: new HttpHeaders({'Content-Type':  'application/json'})};

  constructor(public http: HttpClient,
              private utilityService: UtilityService,
              private rilevazionePresenzeService: RilevazionePresenzeService) {
    console.log('Hello ConfermaPresenzaService Provider');
  }

  // curl -X PUT  -H "Content-type: application/json"  -d @curl.d/richiesta_put.json localhost:8080/docenti1/v1/conferma/richiesta | jq
  public creaRichiesta(rilevazione: Rilevazione, useRilCloseTime = false): Observable<RichiestaDiConferma> {
      let post;
      if (useRilCloseTime) {
        // calcolare il tempo di inse richiesta dalla chiusura della ril
        let diff = (new Date(rilevazione.chiusuraAnticipata).getTime() - new Date(rilevazione.istanteCreazione).getTime()) / 60000
        let istanteRichiesta;
        
        if(diff < 10 && diff > 0) {
          istanteRichiesta = this.utilityService.setUTCTime(rilevazione.istanteCreazione);
        }
        else {
          istanteRichiesta = addMinutes(this.utilityService.setUTCTime(rilevazione.chiusuraAnticipata ? rilevazione.chiusuraAnticipata : rilevazione.chiusura), -10);
        }

        istanteRichiesta = this.utilityService.setLocalTime(istanteRichiesta);

        post = {
          'idRilevazione': rilevazione.id,
          'istanteRichiesta': istanteRichiesta
        };
      } else {
        post = {
          'idRilevazione': rilevazione.id
        };
      }
      console.log('post ' + JSON.stringify(post));
      return this.http.put('conferma/richiesta', JSON.stringify(post), this.optionsContJson).pipe(
        map(r => this.parseRichiestaResponse(r).pop()) );
  }

  private parseRichiestaResponse(response: any): RichiestaDiConferma[] {
          const json = response; // .json(); // e' già un json
          console.log(json);
          if (json) {
            const data: RichiestaDiConferma[] = (Array.isArray(json)) ? json : Array.of(json);
            this.toRichiestaDiConfermaSmart(data);
            return data;
          } else {
            throw response;
          }
  }

  public toRichiestaDiConfermaSmart(richieste: RichiestaDiConferma[]) {
      for (const richiesta of richieste) {
        console.dir(richiesta);
      }
  }

  public inserisciConferme(rilevazione: Rilevazione, defaultTime: Date): Observable<ConfermaPresenza[]> {
      return this.http.put(`conferma/add/${rilevazione.id}`, JSON.stringify(defaultTime), this.optionsContJson)
      .pipe(map(r => this.parseConfermaResponse(r)));
  }

  // rimuoviConferma(cp: ConfermaPresenza): Observable<any> {
  //   return this.http.delete(`conferma/${cp.id}`, this.optionsContJson )
  //     .pipe(map(r => { }));
  // }

  public confermaPresenza(presenza: Presenza, coords: Coordinates, cp: ConfermaPresenza = null): Observable<ConfermaPresenza> {
    let post: ConfermaPresenza;
    if (cp) {
      post = cp;
    } else {
        const conferma: ConfermaPresenza = {
            'idRilevazione': presenza.rilevazione.id,
            'idStudente': presenza.idStudente,
            'matricola': presenza.matricola
        };

        if (coords) {
          conferma['latitudine'] = coords.latitude;
          conferma['longitudine'] = coords.longitude;
          conferma['accuracy'] = coords.accuracy;
        }
        post = conferma;
      }

        return this.http.put(`conferma/${presenza.idStudente}`, JSON.stringify(post), this.optionsContJson).pipe(
          map(r => this.parseConfermaResponse(r).pop()));
    }

    private parseConfermaResponse(response: any): ConfermaPresenza[] {
        if (response instanceof HttpErrorResponse) {
          throw response;
        } else {
          const json = response; // .json();
          const data: ConfermaPresenza[] = (Array.isArray(json)) ? json : Array.of(json);
          return data;
        }
      }

}
